/**
 * Enum of modes when managing slots.
 */
export enum ManageSlotsMode {
  Clear = 'clear',
  Create = 'create'
}
